import { Component } from '@angular/core';
import { ChartService } from '../service/chart.service';
import { ThemeService } from '../service/theme.service';

@Component({
    selector: 'app-log-line-chart',
    templateUrl: './log-line-chart.component.html',
    styleUrls: ['./log-line-chart.component.css', '../../charts.css'],
    standalone: false
})
export class LogLineChartComponent {
  constructor(public charts: ChartService, public theme: ThemeService) {}
}
